import { useEffect } from 'react';

/**
 * Per-page meta override. Title / description set here win over the brand
 * defaults applied by <BrandHead/>. Also mirrors to Open Graph + Twitter
 * card meta so social shares carry the correct page-specific preview.
 */
export default function useDocumentMeta({ title, description } = {}) {
    useEffect(() => {
        const prevTitle = document.title;
        const metaEl = document.querySelector('meta[name="description"]');
        const prevDesc = metaEl ? metaEl.getAttribute('content') : null;

        const ogSelectors = [
            ['meta[property="og:title"]', title],
            ['meta[name="twitter:title"]', title],
            ['meta[property="og:description"]', description],
            ['meta[name="twitter:description"]', description],
        ];
        const prevOg = ogSelectors.map(([sel]) => {
            const el = document.querySelector(sel);
            return el ? el.getAttribute('content') : null;
        });

        if (title) {
            document.title = title;
            ogSelectors.slice(0, 2).forEach(([sel, val]) => {
                const el = document.querySelector(sel);
                if (el && val) el.setAttribute('content', val);
            });
        }
        if (description && metaEl) metaEl.setAttribute('content', description);
        if (description) {
            ogSelectors.slice(2).forEach(([sel, val]) => {
                const el = document.querySelector(sel);
                if (el && val) el.setAttribute('content', val);
            });
        }

        return () => {
            if (title) document.title = prevTitle;
            if (description && metaEl && prevDesc !== null) metaEl.setAttribute('content', prevDesc);
            ogSelectors.forEach(([sel], i) => {
                const el = document.querySelector(sel);
                if (el && prevOg[i] !== null) el.setAttribute('content', prevOg[i]);
            });
        };
    }, [title, description]);
}
